// constants/testIds/ — central registry of data-testid values used by
// end-to-end tests to locate and interact with UI elements. UI without
// testids cannot be automatically verified.
//
// Structure: each feature lives in its own file (auth.js, ...) and
// is re-exported from here, so consumers can do a single import like
// `import { LOGIN } from '@/constants/testIds'` (or relative).
//
// Adding a new feature:
//   1. Create constants/testIds/<feature>.js
//   2. Export named objects (e.g. `export const PROFILE = { ... }`)
//   3. Re-export here: `export * from './<feature>';`

export * from './auth';
export * from './organization';
export * from './location';
export * from './patient';
export * from './encounter';
export * from './appointment';
export * from './user';
export * from './diagnosis';
export * from './cpt';
export * from './medication';
export * from './lab';
export * from './radiology';
export * from './physicianReferral';
export * from './referringProvider';
export * from './smartPhrase';
export * from './placeholderVocabulary';
export * from './dashboard';
export * from './settings';
export * from './pxMaster';
export * from './allergenMaster';
export * from './allergy';
export * from './systemChangeHistory';
export * from './smsSandbox';
export * from './accessControl';
export * from './genericReportDesigner';
export * from './pageDesigner';
